import { render } from "./EditBlog.vue?vue&type=template&id=54a2358e&scoped=true"
import script from "./EditBlog.vue?vue&type=script&lang=js"
export * from "./EditBlog.vue?vue&type=script&lang=js"

import "./EditBlog.vue?vue&type=style&index=0&id=54a2358e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54a2358e"

export default script